import { CguComponent } from "./components/cgu/cgu.component";
import { AideComponent } from "./components/admin/aide/aide.component";
import { ModificationObjectifComponent } from "./components/admin/modification-objectif/modification-objectif.component";
import { AuthGuard } from "./guards/auth.guard";
import { ViewcommandeComponent } from "./components/commandes/viewcommande/viewcommande.component";
import { CommandeDetail } from "src/app/models/CommandeDetail";
import { ChargementDgRevendeurComponent } from "./components/admin/chargement-dg-revendeur/chargement-dg-revendeur.component";
import { ChargementObjectifComponent } from "./components/admin/chargement-objectif/chargement-objectif.component";
import { AgentComponent } from "./components/admin/agent/agent.component";
import { ValidationComponent } from "./components/commandes/validation/validation.component";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AccueilComponent } from "./components/accueil/accueil.component";
import { LoginComponent } from "./components/login/login.component";
import { NewcommandeComponent } from "./components/commandes/newcommande/newcommande.component";
import { ListcommandeComponent } from "./components/commandes/listcommande/listcommande.component";
import { TemplatesComponent } from "./components/templates/templates.component";
import { ProfilComponent } from "./components/admin/profil/profil.component";

import { VenteComponent } from "./components/reporting/vente/vente.component";
import { CommadeComponent } from "./components/reporting/commade/commade.component";
import { CommissionComponent } from "./components/reporting/commission/commission.component";

import { VenteGlobalComponent } from "./components/reporting/vente/vente-global/vente-global.component";
import { VenteWalletComponent } from "./components/reporting/vente/vente-wallet/vente-wallet.component";
import { VenteOmyComponent } from "./components/reporting/vente/vente-omy/vente-omy.component";
import { VenteNafamaComponent } from "./components/reporting/vente/vente-nafama/vente-nafama.component";
import { VenteCarteComponent } from "./components/reporting/vente/vente-carte/vente-carte.component";
import { CommandeCarteComponent } from "./components/reporting/commande/commande-carte/commande-carte.component";
import { CommandeOmyComponent } from "./components/reporting/commande/commande-omy/commande-omy.component";
import { CommandeWalletComponent } from "./components/reporting/commande/commande-wallet/commande-wallet.component";
import { CommandeNafamaComponent } from "./components/reporting/commande/commande-nafama/commande-nafama.component";
import { CommandeGlobalComponent } from "./components/reporting/commande/commande-global/commande-global.component";
import { CashinCashoutComponent } from "./components/reporting/omy/cashin-cashout/cashin-cashout.component";
import { CellinComponent } from "./components/reporting/marge/cellin/cellin.component";
import { CelloutComponent } from "./components/reporting/marge/cellout/cellout.component";
import { MargeArriereComponent } from "./components/reporting/marge/marge-arriere/marge-arriere.component";
import { TableaubordComponent } from "./components/reporting/tableaubord/tableaubord.component";
import { CopdvComponent } from "./components/reporting/copdv/copdv.component";
import { CommandeProduitComponent } from "./components/reporting/commande/commande-produit/commande-produit.component";
import { OperationwalletComponent } from "./components/operation/operationwallet/operationwallet.component";
// import { DistriValidateCommandeComponent } from './components/distri/distri-validate-commande/distri-validate-commande.component';
import { DistriListCommandeComponent } from "./components/distri/distri-list-commande/distri-list-commande.component";
import { DistriValidateCommandeComponent } from "./components/distri/distri-validate-commande/distri-validate-commande.component";
import { CommissionsComponent2 } from "./components/reporting/performance/commissions.component";
import { PerformanceComponent } from "./components/reporting/performance/performance.component";

const appRoutes: Routes = [
  {
    path: "root",
    component: TemplatesComponent,
    children: [
      {
        path: "accueil",
        component: AccueilComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "new-commande",
        component: NewcommandeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "list-commande",
        component: ListcommandeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "etat-commande",
        component: DistriListCommandeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "validation-commande",
        component: DistriListCommandeComponent,
        canActivate: [AuthGuard],
      },
      // {path: 'validation-commande', component: DistriListCommandeComponent },
      {
        path: "validate-commande-details",
        component: DistriValidateCommandeComponent,
      },
      {
        path: "detail-commande",
        component: ViewcommandeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "gestion-agent",
        component: AgentComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "gestion-profil",
        component: ProfilComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "chargement-objectif",
        component: ChargementObjectifComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "modification-objectif",
        component: ModificationObjectifComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "chargement-dg-revendeur",
        component: ChargementDgRevendeurComponent,
        canActivate: [AuthGuard],
      },
      { path: "aide", component: AideComponent, canActivate: [AuthGuard] },
      { path: "cgu", component: CguComponent, canActivate: [AuthGuard] },

      { path: "vente", component: VenteComponent, canActivate: [AuthGuard] },
      {
        path: "commande",
        component: CommadeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "commission",
        component: CommissionComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "vente-global",
        component: VenteGlobalComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "vente-nafama",
        component: VenteNafamaComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "vente-omy",
        component: VenteOmyComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "vente-carte",
        component: VenteCarteComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "vente-wallet",
        component: VenteWalletComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "commande-global",
        component: CommandeGlobalComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "commande-omy",
        component: CommandeOmyComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "commande-nafama",
        component: CommandeNafamaComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "commande-wallet",
        component: CommandeWalletComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "commande-carte",
        component: CommandeCarteComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "commande-produit",
        component: CommandeProduitComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "marge-cellin",
        component: CellinComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "marge-cellout",
        component: CelloutComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "marge",
        component: MargeArriereComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "cashin-cashout",
        component: CashinCashoutComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "tableau-bord",
        component: TableaubordComponent,
        canActivate: [AuthGuard],
      },
      { path: "copdv", component: CopdvComponent, canActivate: [AuthGuard] },

      //   {
      //     path: "reporting",
      //     component: ReportingComponent,
      //     canActivate: [AuthGuard],
      //   },

      {
        path: "reporting-com",
        component: CommissionsComponent2,
        canActivate: [AuthGuard],
      },

      {
        path: "reporting",
        component: PerformanceComponent,
        canActivate: [AuthGuard],
      },

      {
        path: "op-dualwallet",
        component: OperationwalletComponent,
        canActivate: [AuthGuard],
      },

      {
        path: "gestion-agent",
        component: AgentComponent,
        canActivate: [AuthGuard],
      },
    ],
  },

  { path: "login", component: LoginComponent },
  { path: "", redirectTo: "/root/accueil", pathMatch: "full" }, // page index (default)
  { path: "**", redirectTo: "/root/accueil" }, // page 404
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
